import {observer} from "mobx-react";
import {AppHeader, AppPage} from "../../../app";
import {Dialog, Pager, SearchInputField} from "../../../ui";
import {RegistrationOverviewFilter} from "./RegistrationOverviewFilter";
import {RegistrationOverviewList} from "./RegistrationOverviewList";
import {
    authStore,
    createRegistrationStore,
    DialogStore,
    featureStore,
    growlStore,
    registrationExportStore,
    registrationOverviewFilterStore,
    registrationOverviewStore
} from "../../../../store";

import "./RegistrationOverviewPage.scss"
import {useNavigate, useSearchParams} from "react-router-dom";
import {useEffect, useState} from "react";
import {CreateRegistrationForm} from "../detail/CreateRegistrationForm";
import {GetActiveProcedureEnum, orderType,} from "../../../../api";
import {saveData} from "../../../../utils";


function isFiltered(params: URLSearchParams): string {
    return params.get("types")
    || params.get("status")
    || params.get("from")
    || params.get("to")
    || params.get("archived") !== null
    || params.get("organisationId")
        ? "filter-is-active"
        : ""
}


const CreateRegistrationDialog = observer(function CreateRegistrationDialog({dialogStore}: {
    dialogStore: DialogStore
}) {
    const navigate = useNavigate()
    const serviceType = createRegistrationStore.serviceType
    const organization = createRegistrationStore.organization
    const city = createRegistrationStore.city
    const zip = createRegistrationStore.zip
    const ready = createRegistrationStore.ready
    const procedureIcon = createRegistrationStore.procedure ? (createRegistrationStore.procedure === GetActiveProcedureEnum.AUTOMATIC ?
        'is-info' : (createRegistrationStore.procedure === GetActiveProcedureEnum.SEMI_AUTOMATIC ? 'is-warning' : 'is-danger')) : ''

    const procedureText = createRegistrationStore.procedure === GetActiveProcedureEnum.AUTOMATIC ?
        'Der Zulassungsprozess ist vollautomatisiert':(
                createRegistrationStore.procedure === GetActiveProcedureEnum.SEMI_AUTOMATIC ?
                    'Der Zulassungsprozess ist teilautomatisiert' : (
                    createRegistrationStore.procedure === GetActiveProcedureEnum.NONE ?
                        'Es ist keine Information zu der Automatisierung des Zulassungsprozesses vorhanden'
                        : 'Eine valide Postleitzahl und Ort wird benötigt, um das Level der Automatisierung im Zulassungsprozess abzufragen'
                )
            )

    useEffect(() => {
        dialogStore.primaryReady = ready
    }, [ready, dialogStore])

    return <>
        <Dialog store={dialogStore} title={"Neuen Vorgang anlegen"} titleCloseable={false}
                id={'create-registration-dialog'}
                primaryAction={async () => {
                    // store.close()
                    // navigate
                    dialogStore.primaryExecuting = true
                    const reg = await createRegistrationStore.save()
                    dialogStore.primaryExecuting = false
                    if (reg) {
                        navigate(`/registration/${reg.id}`)
                        return true
                    }
                    return null
                }}
                primaryActionTitle={`${orderType(createRegistrationStore.serviceType)} anlegen`}>
            <CreateRegistrationForm
                serviceType={serviceType}
                organization={organization}
                city={city}
                zip={zip}
                onChange={v => {
                    createRegistrationStore.serviceType = v.serviceType
                    createRegistrationStore.organization = v.organization
                    createRegistrationStore.setCitySelection(v.city && v.zip ? {
                        city: v.city,
                        zip: v.zip
                    } : undefined)
                    dialogStore.primaryReady = createRegistrationStore.ready
                }}
            />
            {!createRegistrationStore.isDeregistration && <div className={`notification ${procedureIcon}`}>{procedureText}</div>}
        </Dialog>
    </>
})

const exportCsv = async function () {
    const exportFinished = registrationExportStore.prepareExport();
    await registrationExportStore.startExport()
    await exportFinished
    growlStore.addMessage({
        message: 'Ihr Export ist bereit',
        action: async () => {
            const blob = await registrationExportStore.downloadDocument()
            if (blob) {
                saveData(blob, "Zulassungen-Export.csv")
            }
        },
        actionLabel: "Herunterladen"
    })
}

const RegistrationOverviewPage = observer(function RegistrationOverviewPage() {
    const [createDialogStore] = useState(new DialogStore())
    const [searchParams,] = useSearchParams()
    const isFilteredCSS = isFiltered(searchParams)
    const [dialogStore] = useState(new DialogStore())

    function openCreateDialog() {
        dialogStore.modalStore.open()
    }
    return <AppPage>
        <AppHeader title={"Übersicht"}>
            <SearchInputField></SearchInputField>
            <button className={`button is-light compact-button ${isFilteredCSS}`}
                    title={registrationOverviewFilterStore.visible ? "Filterpanel schließen" : "Filterpanel öffnen"}
                    onClick={() => {
                        registrationOverviewFilterStore.visible = !registrationOverviewFilterStore.visible
                    }}>
                <span className="material-symbols-outlined">tune</span>
            </button>
            {featureStore.isActive('REGISTRATION_EXPORT') && authStore.isAdmin &&
                <button
                    className={`button is-light compact-button ${registrationExportStore.exportRunning ? 'is-loading' : ''}`}
                    title={"Export als CSV"} onClick={() => openCreateDialog()}>
                    <span className="material-symbols-outlined">download</span>
                </button>}
            <span style={{marginRight: '1em'}}></span>
            <button id={"start-registration-button"} className={`button is-primary`}
                    onClick={() => {
                        createRegistrationStore.reset()
                        createDialogStore.open()
                    }}>Neuer Vorgang
            </button>
        </AppHeader>
        <Dialog store={dialogStore} title={<>
            <span className="material-symbols-outlined" style={{color: "var(--bulma-primary)", marginRight: "0.25em"}}>warning</span> Daten exportieren
        </>} primaryAction={async () => {
            await exportCsv()
            return true
        }} primaryActionTitle={"Exportieren"}>
            Achtung dieser Export hat bis zu {registrationOverviewStore.totalPages * registrationOverviewStore.size} Einträge.
        </Dialog>
        <div className={"registration-overview-page"}>
            <div className={`filter ${registrationOverviewFilterStore.visible ? "expanded" : ""}`}>
                <RegistrationOverviewFilter/>
            </div>
            <div className={"registration-overview-list"}>
                <RegistrationOverviewList/>
            </div>
        </div>
        <Pager total={registrationOverviewStore.totalPages}/>
        <CreateRegistrationDialog dialogStore={createDialogStore}/>
    </AppPage>
})

export {
    RegistrationOverviewPage
}
